// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { footerContainerStyles } from "@rpsc/Overrides/Widgets/Footer/FooterContainer";
import { color, layoutContainer, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

footerContainerStyles.container = {
    css: css`
        background-color: ${color("common.ui2")};
    `,
};

footerContainerStyles.subscriptionWrapper = {
    css: css`
        width: 100%;
        position: relative;
        top: -48px;
        margin-bottom: -48px; // reset the space
        ${xScreen("lte", "md")} {
            position: unset;
            margin-bottom: 0;
        }
    `,
};

footerContainerStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 32px;
        padding-bottom: 16px;
        ${({ isCheckoutPage }: any) => isCheckoutPage && `padding: 12px 0`};
    `,
};

footerContainerStyles.topSectionGridContainer = {
    gap: 22,
    css: css`
        ${layoutContainer}
        padding-top: 24px;
    `,
};

footerContainerStyles.logoSocialLinksGridContainer = {
    gap: 22,
    offsetCss: css`
        align-items: center;
    `,
};

footerContainerStyles.logoSocialLinksGridItem = {
    width: [12, 4, 4, 2, 2],
};

footerContainerStyles.logoGridItem = {
    width: 6,
    css: css`
        ${xScreen("lte", "md")} {
            max-width: 113px;
        }
    `,
};

footerContainerStyles.certificateGridItem = {
    width: 6,
};

footerContainerStyles.socialLinksGridItem = {
    width: 12,
};

footerContainerStyles.infoGridItem = {
    width: [12, 12, 12, 6, 6],
};

footerContainerStyles.infoGridContainer = {
    gap: 22,
};

footerContainerStyles.linkListGridItem = {
    width: [6, 6, 4, 4, 4],
};

footerContainerStyles.richContentGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        > div:first-child {
            border-left: 1px solid ${color("common.black")};
            padding-left: 8px;
            ${xScreen("lte", "md")} {
                border-top: 1px solid ${color("common.black")};
                border-left: none;
                padding: 8px 0 0;
            }
        }
    `,
};

footerContainerStyles.bottomSectionGridContainer = {
    gap: 22,
    css: css`
        ${layoutContainer}
    `,
};

footerContainerStyles.copyrightGridItem = {
    width: [12, 12, 12, 3, 3],
};

footerContainerStyles.copyrightText = {
    size: 12,
    lineHeight: "17px",
    color: "common.black",
};

footerContainerStyles.siteMapLinksGridItem = {
    width: [12, 12, 12, 9, 9],
};
